export default __webpack_public_path__ + "static/media/mc-logo.94d1881d.svg";